import React, { Component, Fragment } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaEnvelope } from "react-icons/fa";




import AppURL from '../../api/AppURL';
import axios from 'axios';
import parse from 'html-react-parser';

class FooterDesktop extends Component {

  constructor() {
    super();
    this.state = {
      address: "",
      android_app_link: "",
      ios_app_link: "",
     facbook_link: "https://www.facebook.com/ChrisAlphaTechCompany/",
      instagram_link: "https://www.instagram.com/chrisalphatechcompany/",
      youtube_link: "https://www.youtube.com/@ChrisAlphaTechCompany",
     tiktok_link: "https://www.tiktok.com/@chris.alpha.tech",
      linkedin_link: "https://www.linkedin.com/in/chrisalpha-tech-company-limited-4179b12b1",
      whatsapp_link: "https://wa.me/256784226089",


      copyright_text: "",
      loaderDiv: "",
      mainDiv: "d-none"
    }
  }

  componentDidMount() {
    axios.get(AppURL.AllSiteInfo)
      .then(response => {

        if (response.status === 200) {
          let JsonData = response.data[0];

          this.setState({
            address: JsonData['address'],
            android_app_link: JsonData['android_app_link'],
            ios_app_link: JsonData['ios_app_link'],      

            copyright_text: JsonData['copyright_text'],
            loaderDiv: "d-none",
            mainDiv: ""
          });
        }

      })
      .catch(error => {
        console.log(error);
      });
  }

  render() {
    return (
      <Fragment>

        <div className="footerback m-0 mt-5 pt-3 shadow-sm">
          <Container>

            <Row className="px-0 my-5">

              {/* Address & Social */}
              <Col className="p-2" lg={3} md={3} sm={6} xs={12}>

                {/* Loader */}
                <div className={this.state.loaderDiv}>
                  <div className="ph-item">
                    <div className="ph-col-12">
                      <div className="ph-row">
                        <div className="ph-col-4"></div>
                        <div className="ph-col-8 empty"></div>
                        <div className="ph-col-6"></div>
                        <div className="ph-col-6 empty"></div>
                        <div className="ph-col-12"></div>
                        <div className="ph-col-12"></div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Main Content */}
                <div className={this.state.mainDiv}>
                  <h5 className="footer-menu-title"> ADDRESS</h5>
                  {parse(this.state.address)}
                 
              
                </div>

              </Col>


              {/* Company */}
              <Col className="p-2" lg={3} md={3} sm={6} xs={12}>
                <h5 className="footer-menu-title">MORE LINKS</h5>

                <Link to="/about" className="footer-link">About Us</Link><br />
                <Link to="/contact" className="footer-link">Contact Us</Link><br />
               <Link to="/newlettersubscribe" className="footer-link">Subscribe</Link><br />
                <Link to="/requestquote" className="footer-link">Request For Quote</Link><br />


              </Col>

              {/* More Info */}
              <Col className="p-2" lg={3} md={3} sm={6} xs={12}>
                <h5 className="footer-menu-title">MORE INFO</h5>

                <Link to="/products" className="footer-link">Our Products</Link><br />
                <Link to="/services" className="footer-link">Our Services</Link><br />
                <Link to="/livedemo" className="footer-link">Live Demo</Link><br />
                <Link to="/ourclients" className="footer-link">Our Clients</Link><br />

              </Col>

              {/* Apps */}
              <Col className="p-2" lg={3} md={3} sm={6} xs={12}>




                <h5 className="footer-menu-title">OUR SOCIAL MEDIA</h5>

<div className="social-icons">
                    
{/* FACEBOOK */}
 <a href={this.state.facbook_link} target="_blank" rel="noopener noreferrer"> <i className="fab m-1 h4 fa-facebook"></i> </a>

{/* YOUTUBE */} 
<a href={this.state.youtube_link} target="_blank" rel="noopener noreferrer"> <i className="fab m-1 h4 fa-youtube"></i> </a>

{/* INSTAGRAM */} 
<a href={this.state.instagram_link} target="_blank" rel="noopener noreferrer"> <i className="fab m-1 h4 fa-instagram"></i> </a>

{/* LINKEDIN */}
 <a href={this.state.linkedin_link} target="_blank" rel="noopener noreferrer"> <i className="fab m-1 h4 fa-linkedin"></i> </a>

{/* TIKTOK */} 
<a href={this.state.tiktok_link} target="_blank" rel="noopener noreferrer"> <i className="fab m-1 h4 fa-tiktok"></i> </a>
<a 
  href={this.state.whatsapp_link}  target="_blank"   rel="noopener noreferrer"> <i className="fab m-1 h4 fa-whatsapp"></i></a>
</div>


  
              </Col>

            </Row>

          </Container>

          {/* Footer Bottom */}
          <Container fluid={true} className="text-center m-0 pt-3 pb-1 bg-dark">
            <Container>
              <Row>
                <h6 className="text-white">
                  {parse(this.state.copyright_text)}
                </h6>
              </Row>
            </Container>
          </Container>

        </div>

      </Fragment>
    )
  }
}

export default FooterDesktop;